<template>
  <div>
    <div class="row">
      <div class="col-4 col-md-3">
        <under-input v-model="item.core.ancestry">
          Ancestry
        </under-input>
      </div>
      <div class="col-4 col-md-3">
        <under-input v-model="item.core.background">
          Background
        </under-input>
      </div>
      <div class="col-4 col-md-3">
        <under-input v-model="item.core.class">
          Class
        </under-input>
      </div>
      <div class="col-8 col-md-2">
        <under-input v-model="item.core.experience">
          Experience
        </under-input>
      </div>
      <div class="col-4 col-md-1">
        <under-text>
          <span slot="underline">{{level}}</span>
          Level
        </under-text>
      </div>
    </div>
     <div class="row">
      <div class="col-6 col-md-3">
        <under-select v-model="item.core.size" :options="size">
          Size
        </under-select>
      </div>
      <div class="col-6 col-md-3">
        <under-select v-model="item.core.alignment" :options="alignment">
          Alignment
        </under-select>
      </div>
      <div class="col-4 col-md-3">
        <under-input v-model="item.core.deity">
          Deity
        </under-input>
      </div>
      <div class="col-4 col-md-2">
        <under-input v-model="item.core.gender">
          Gender
        </under-input>
      </div>
      <div class="col-4 col-md-1">
        <under-input v-model="item.core.age">
          Age
        </under-input>
      </div>
    </div>
  </div>
</template>
<script>
import UnderInput from "../shared/_UnderInput.vue";
import UnderSelect from "../shared/_UnderSelect.vue";
import UnderText from "../shared/_UnderText.vue";

export default {
  name: "character-sheet-core-pfrpg2",
  components: {
    UnderInput,
    UnderSelect,
    UnderText
  },
  props: ["item"],
  computed: {
    level() {
      return this.$rpgv.d20.level(this.item.ruleset, this.item.core.experience);
    },
    alignment() {
      let options = [];
      /* eslint-disable-next-line vue/no-side-effects-in-computed-properties */
      this.$rpgv.d20.alignment.forEach(element => {
        options.push({ text: element, value: element });
      });
      return options;
    },
    size() {
      let options = [];
      Object.keys(this.$rpgv.d20.size).forEach(function(element) {
        options.push({ text: element, value: element });
      });
      return options;
    }
  }
};
</script>
